export const MANAGE_ASSETS_TAB_SLUGS = [
  "apis",
  "faqs",
  "links",
  "documents",
  "categories",
  "products",
] as const;

export type ManageAssetsTabSlug = (typeof MANAGE_ASSETS_TAB_SLUGS)[number];

const SLUG_TO_INDEX: Record<ManageAssetsTabSlug, number> = {
  apis: 0,
  faqs: 1,
  links: 2,
  documents: 3,
  categories: 4,
  products: 5,
};

const INDEX_TO_SLUG: ManageAssetsTabSlug[] = [
  "apis",
  "faqs",
  "links",
  "documents",
  "categories",
  "products",
];

export function tabSlugToIndex(slug: string | null): number {
  if (slug && slug in SLUG_TO_INDEX) {
    return SLUG_TO_INDEX[slug as ManageAssetsTabSlug];
  }
  return 0;
}

export function tabIndexToSlug(index: number): ManageAssetsTabSlug {
  return INDEX_TO_SLUG[index] ?? "apis";
}

export function manageAssetsPath(tab: ManageAssetsTabSlug = "apis"): string {
  return `/manage-assets?tab=${tab}`;
}
